import {page as _page} from './utilities';

export default {
    data: () => ({
        pageSize: 10,
        pagedData: [],
        currentPage: 1
    }),
    methods:{
        pageData(data = [], page){
            this.pagedData = _page(data, page, this.pageSize);
            this.currentPage = page;
            return this.pagedData;
        },

        pageChange(page, data){
            this.pagedData = this.pageData(data, page);
        }

    }
}
